import { SanityImagePalette } from '@/lib/schemas/sanity-image-palette';
import { SanityImagePaletteSwatch } from '@/lib/schemas/sanity-image-palette-swatch';
import {
  HierarchyRectangularNode,
  hierarchy,
  treemap,
  treemapSquarify,
} from 'd3-hierarchy';

type Node = {
  name: string;
  color: SanityImagePaletteSwatch['background'];
  total: SanityImagePaletteSwatch['population'];
};

export type Treemap = HierarchyRectangularNode<{
  children: Node[];
}>[];

export function createTreemapFromPalette(palette: SanityImagePalette): Treemap {
  const paletteData: { children: Node[] } = {
    children: [
      {
        name: 'darkMuted',
        color: palette.darkMuted.background,
        total: palette.darkMuted.population,
      },
      {
        name: 'darkVibrant',
        color: palette.darkVibrant.background,
        total: palette.darkVibrant.population,
      },
      {
        name: 'lightMuted',
        color: palette.lightMuted.background,
        total: palette.lightMuted.population,
      },
      {
        name: 'lightVibrant',
        color: palette.lightVibrant.background,
        total: palette.lightVibrant.population,
      },
      {
        name: 'muted',
        color: palette.muted.background,
        total: palette.muted.population,
      },
      {
        name: 'vibrant',
        color: palette.vibrant.background,
        total: palette.vibrant.population,
      },
    ],
  };

  const root = hierarchy(paletteData).sum((d) => (d as unknown as Node).total);

  return treemap<{ children: Node[] }>()
    .tile(treemapSquarify)
    .size([100, 100])
    .padding(0)
    .round(true)(root)
    .leaves();
}
